import { useSelector } from 'react-redux';

import {
  selectCurrentRequestData,
  selectFilterCriteriaData,
  selectFilterData
} from 'pages/MaintenanceRequests/selectors';

export default function useMaintenanceRequestSelector() {
  const filter = useSelector(selectFilterData());
  const filterCriteria = useSelector(selectFilterCriteriaData());

  const currentRequest = useSelector(selectCurrentRequestData());

  return {
    filter,
    filterCriteria,
    currentRequest
  };
}
